import { t } from 'services/i18n.service';

export const STATS = {
  DASHBOARD_TABS: [
    'stats_page.progress',
    'stats_page.streak',
    'stats_page.leader_board',
    'stats_page.habit_stats',
    'stats_page.productivity',
    'stats_page.focus_summary'
  ],
  EMBEDDED_TABS: [
    'stats_page.goals',
    'stats_page.progress',
    'stats_page.streak',
    'stats_page.get_motivated',
    'stats_page.leader_board',
    'stats_page.habit_stats',
    'stats_page.productivity',
    'stats_page.focus_summary'
  ],
  FOCUS_SUMMARY: {
    WEEKLY: {
      COLUMN: [
        'weekly_focus_block_summary.duration',
        'weekly_focus_block_summary.start_time',
        'weekly_focus_block_summary.finish_time',
        'weekly_focus_block_summary.intention',
        'weekly_focus_block_summary.distractions',
        'weekly_focus_block_summary.name',
        ''
      ],
      KEY: [
        'focus_duration_seconds',
        'start_time',
        'finish_time',
        'intention',
        'distractions',
        'focus_mode.name'
      ],
      EXPORT_COLUMN: [
        'weekly_focus_block_summary.name',
        'weekly_focus_block_summary.duration',
        'weekly_focus_block_summary.start_time',
        'weekly_focus_block_summary.finish_time',
        'weekly_focus_block_summary.intention',
        'weekly_focus_block_summary.achievements',
        'weekly_focus_block_summary.distractions'
      ]
    }
  }
};

export const LEADER_BOARD = {
  COLUMNS: [
    'leader_board.rank',
    'leader_board.name',
    'leader_board.morning_streak',
    'leader_board.break_streak',
    'leader_board.evening_streak',
    'leader_board.focus_mode'
  ],
  SORT: [
    'leader_board.morning_streak',
    'leader_board.break_streak',
    'leader_board.evening_streak'
  ],
  STAT_LIMIT: 20
};

export const ADMIN_SURVEY = {
  COLUMNS: ['admin.question', 'admin.category', 'admin.choices'],
  SORT: []
};

export const ADMIN_ANNOUNCEMENT = {
  COLUMNS: [
    'admin.announcement_heading',
    'admin.announcement_type',
    'admin.announcement_priority',
    'admin.announcement_os',
    'admin.announcement_expiry',
    'admin.announcement_status'
  ],
  SORT: []
};

export const ADMIN_TEAMS_TABLE = {
  COLUMNS: [
    'admin_teams.column_name',
    'admin_teams.column_owner_email',
    'admin_teams.column_payment_type',
    'admin_teams.column_members',
    'admin_teams.column_expires',
    'admin_teams.column_active',
    'admin_teams.column_type'
  ]
};

export const TEAM_COLUMN_TITLES = {
  EMAIL: t('email'),
  NAME: t('admin_team.name'),
  INVITATION_STATUS: t('admin_team.invitation_status'),
  MEMBER_TYPE: t('admin_team.member_type'),
  HAS_ACCESS: t('admin_team.has_access'),
  PERCENT_DAYS_USED: t('admin_team.percent_days_used_in_last_ninety_days')
};

export const TEAM_MEMBERS_COLUMNS = [
  { title: '', shouldSortAllowed: false },
  {
    title: TEAM_COLUMN_TITLES.EMAIL,
    shouldSortAllowed: true
  },
  {
    title: TEAM_COLUMN_TITLES.NAME,
    shouldSortAllowed: true
  },
  {
    title: TEAM_COLUMN_TITLES.INVITATION_STATUS,
    shouldSortAllowed: true
  },
  {
    title: TEAM_COLUMN_TITLES.MEMBER_TYPE,
    shouldSortAllowed: true
  },
  {
    title: TEAM_COLUMN_TITLES.HAS_ACCESS,
    shouldSortAllowed: true
  },
  {
    title: TEAM_COLUMN_TITLES.PERCENT_DAYS_USED,
    shouldSortAllowed: true
  }
];

export const TEAM_MEMBERS_COLUMN_COUNT = TEAM_MEMBERS_COLUMNS.length;

export const WEEKLY_SUMMARY_COLUMNS = [
  'dashboard_stat.day',
  'dashboard_stat.morning_routine',
  'dashboard_stat.evening_routine',
  'dashboard_stat.activities',
  'dashboard_stat.focus_blocks'
];
